import OpacityPanelSection from './OpacityPanelSection';

export default OpacityPanelSection;